import './class-component-hooks';
import Vue from 'vue';
import App from './App.vue';
import router, {registerRouterHooks} from './router';
import loadConfig from './config/config';
import {store} from './store';
import { FontAwesomeIcon } from './fontawesome';
import VueClipboard from 'vue-clipboard2';
import VueTextareaAutosize from 'vue-textarea-autosize';
import VTooltip from 'v-tooltip';

import '@simonwep/pickr/dist/themes/monolith.min.css';
import '@simonwep/pickr/dist/themes/classic.min.css';

import {LOAD_WORKSPACES} from './store/app/actionTypes';
import authService from './authentication/authentication.service';
import 'vue-material-design-icons/styles.css';

import Chart from 'chart.js';

// @ts-ignore
import * as crosshair from 'chartjs-plugin-crosshair';
import * as annotation from 'chartjs-plugin-annotation';
import { doughnutlabel } from './features/reports/components/chartjs/plugins/doughnutLabels/plugin';
import { inlineLabelsPlugin } from './features/reports/components/chartjs/plugins/inlineLabelsPlugin';

import VueSanitize from 'vue-sanitize';
import { LOAD_CONTACT_ATTRIBUTES } from '@/store/attributes/actionTypes';
import { GET_CHANNEL_IDENTITIES } from './store/channel-identities/actionTypes';

import VCalendar from 'v-calendar';

import appInsights from './shared/services/appInsights';

import ComponentLibrary from '@netcall/design-system';
import './style.scss';

Chart.plugins.register(crosshair);
Chart.plugins.register(doughnutlabel);
Chart.plugins.register(inlineLabelsPlugin);
Chart.plugins.register(annotation);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VueClipboard);
Vue.use(VueTextareaAutosize);
Vue.use(VTooltip);
Vue.use(VueSanitize);
Vue.use(ComponentLibrary);
Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

init().then();

async function init() {
	await loadConfig;
	authService.setup();
	await authService.load(); // need to wait for initial redirect to complete

	appInsights.init(); // Initialise the app insights service
	registerRouterHooks(); // only enforce authentication in our routes once we know the auth service has been initialised

	if (authService.isAuthenticated() && authService.isConnectUser()) {
		appInsights.setAuthenticatedUserContext();
		await store.dispatch(LOAD_WORKSPACES);
		await store.dispatch(LOAD_CONTACT_ATTRIBUTES);
		await store.dispatch(GET_CHANNEL_IDENTITIES);
	}

	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app');
}
